/**
 * C operator precedence table for the CppGenerator.
 *
 * Blockly compares the order value returned by a value handler against the
 * order requested by the consuming context: if the value's order is weaker
 * (numerically larger) than required, the generator parenthesizes it.
 * Numbers mirror standard C precedence so emitted code matches what a
 * programmer would write.
 */
export const Order = {
  /** Statement contexts — never parenthesized. */
  NONE: 0,
  /** Atoms: literals, identifiers, single function calls. */
  ATOMIC: 0,
  MEMBER: 2.1,
  FUNCTION_CALL: 4.1,
  LOGICAL_NOT: 7.1,
  UNARY: 9.1,
  MULTIPLICATIVE: 10.1,
  ADDITIVE: 11.1,
  RELATIONAL: 13.1,
  EQUALITY: 14.1,
  LOGICAL_AND: 18.1,
  LOGICAL_OR: 19.1,
} as const;
